module.exports = __webpack_public_path__ + "static/media/tracebot_sad@3x.826f5af6.png";